// extracted by mini-css-extract-plugin
export default {"tabContainer":"ActivityLogs_tabContainer__+UHGG","tabLabel":"ActivityLogs_tabLabel__25e4o","selectedTabLabel":"ActivityLogs_selectedTabLabel__Zxssk"};